import CopyPaste from '@pinecast/common/icons/CopyPaste';
import RightArrowSmall from '@pinecast/common/icons/RightArrowSmall';
import Link from '@pinecast/common/Link';
import TextInput from '@pinecast/common/TextInput';
import type {ElementConfig} from '@pinecast/common/types';
import {useIntl} from '@pinecast/i18n';
import * as React from 'react';

type Props = {
  disableVisit?: boolean;
  value: string;
  suffix?: React.ReactNode;
} & Omit<ElementConfig<typeof TextInput>, 'value' | 'suffix' | 'readOnly'>;

const ReadOnlyLinkInput = ({disableVisit, value, suffix, ...rest}: Props) => {
  const intl = useIntl();
  const ref = React.useRef<HTMLInputElement | null>(null);
  return (
    <TextInput
      readOnly
      ref={ref}
      value={value}
      suffix={[
        <Link
          aria-label={intl.formatMessage({
            description: 'Label for button to copy URL',
            defaultMessage: 'Copy link to clipboard',
          })}
          onClick={() => {
            navigator.clipboard.writeText(value);
            ref.current!.select();
          }}
        >
          <CopyPaste size={16} style={{display: 'block'}} />
        </Link>,
        !disableVisit && (
          <Link
            aria-label={intl.formatMessage({
              description: 'Label for button to open URL',
              defaultMessage: 'Open link',
            })}
            href={value}
            target="_blank"
          >
            <RightArrowSmall />
          </Link>
        ),
        suffix,
      ]}
      {...rest}
    />
  );
};

export default React.memo(ReadOnlyLinkInput);
